import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const projectTreeStyle = style({
    width: 320,
    padding: CommonStyles.Sizes.LargeSpace,
    borderRight: `1px solid ${TabStyles.Colors.L6}`
});

 export const projectTreeNodeStyle = style({
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    fontSize: 14,
    gap: 5
});

export const projectTreeNodeTextContainerStyle = style({
    position: 'relative',
    flex: '1 1 auto',
    height: '100%'
});

export const projectTreeNodeTextStyle = style({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  position: 'absolute'
});
